export const FETCH_USERS_REQUESTING = 'users/FETCH_USERS_REQUESTING';
export const FETCH_USERS_SUCCESS = 'users/FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILED = 'users/FETCH_USERS_FAILED';

export const CREATE_USER_REQUESTING = 'users/CREATE_USER_REQUESTING';
export const CREATE_USER_SUCCESS = 'users/CREATE_USER_SUCCESS';
export const CREATE_USER_FAILED = 'users/CREATE_USER_FAILED';

export const UPDATE_USER_REQUESTING = 'users/UPDATE_USER_REQUESTING';
export const UPDATE_USER_SUCCESS = 'users/UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILED = 'users/UPDATE_USER_FAILED';

export const DELETE_USER_REQUESTING = 'users/DELETE_USER_REQUESTING';
export const DELETE_USER_SUCCESS = 'users/DELETE_USER_SUCCESS';
export const DELETE_USER_FAILED = 'users/DELETE_USER_FAILED';

export const FETCH_ROLES_REQUESTING = 'users/FETCH_ROLES_REQUESTING';
export const FETCH_ROLES_SUCCESS = 'users/FETCH_ROLES_SUCCESS';
export const FETCH_ROLES_FAILED = 'users/FETCH_ROLES_FAILED';

export const CREATE_ROLE_REQUESTING = 'users/CREATE_ROLE_REQUESTING';
export const CREATE_ROLE_SUCCESS = 'users/CREATE_ROLE_SUCCESS';
export const CREATE_ROLE_FAILED = 'users/CREATE_ROLE_FAILED';

export const UPDATE_ROLE_REQUESTING = 'users/UPDATE_ROLE_REQUESTING';
export const UPDATE_ROLE_SUCCESS = 'users/UPDATE_ROLE_SUCCESS';
export const UPDATE_ROLE_FAILED = 'users/UPDATE_ROLE_FAILED';

export const DELETE_ROLE_REQUESTING = 'users/DELETE_ROLE_REQUESTING';
export const DELETE_ROLE_SUCCESS = 'users/DELETE_ROLE_SUCCESS';
export const DELETE_ROLE_FAILED = 'users/DELETE_ROLE_FAILED';

export const SUSPEND_USER_REQUESTING = 'users/SUSPEND_USER_REQUESTING';
export const SUSPEND_USER_SUCCESS = 'users/SUSPEND_USER_SUCCESS';
export const SUSPEND_USER_FAILED = 'users/SUSPEND_USER_FAILED';

export const ACTIVATE_USER_REQUESTING = 'users/ACTIVATE_USER_REQUESTING';
export const ACTIVATE_USER_SUCCESS = 'users/ACTIVATE_USER_SUCCESS';
export const ACTIVATE_USER_FAILED = 'users/ACTIVATE_USER_FAILED';

// User detail
export const FETCH_USER_DETAIL_REQUESTING = 'users/FETCH_USER_DETAIL_REQUESTING';
export const FETCH_USER_DETAIL_SUCCESS = 'users/FETCH_USER_DETAIL_SUCCESS';
export const FETCH_USER_DETAIL_FAILED = 'users/FETCH_USER_DETAIL_FAILED';
export const CLEAR_USER_DETAIL = 'users/CLEAR_USER_DETAIL';

// User stats
export const FETCH_USER_STATS_REQUESTING = 'users/FETCH_USER_STATS_REQUESTING';
export const FETCH_USER_STATS_SUCCESS = 'users/FETCH_USER_STATS_SUCCESS';
export const FETCH_USER_STATS_FAILED = 'users/FETCH_USER_STATS_FAILED';

// User activite
export const FETCH_USER_ACTIVITE_REQUESTING = 'users/FETCH_USER_ACTIVITE_REQUESTING';
export const FETCH_USER_ACTIVITE_SUCCESS = 'users/FETCH_USER_ACTIVITE_SUCCESS';
export const FETCH_USER_ACTIVITE_FAILED = 'users/FETCH_USER_ACTIVITE_FAILED';

// User decisions
export const FETCH_USER_DECISIONS_REQUESTING = 'users/FETCH_USER_DECISIONS_REQUESTING';
export const FETCH_USER_DECISIONS_SUCCESS = 'users/FETCH_USER_DECISIONS_SUCCESS';
export const FETCH_USER_DECISIONS_FAILED = 'users/FETCH_USER_DECISIONS_FAILED';
